import { LucideProps } from "lucide-react";
import dynamicIconImports from "lucide-react/dynamicIconImports";
import { lazy, Suspense, memo } from "react";

interface IconProps extends Omit<LucideProps, "ref"> {
  name: keyof typeof dynamicIconImports;
}

const NodeIcon = ({ name, ...props }: IconProps) => {
  const iconImporter = dynamicIconImports[name] ?? dynamicIconImports.circle;
  const LucideIcon = lazy(iconImporter);
  return (
    <Suspense fallback={<></>}>
      <LucideIcon {...props} />
    </Suspense>
  );
};

export default memo(NodeIcon);
